import * as React from 'react';
import { EmployeeToken, permissionGroupHelper, UserToken } from '../../amorg-common';
import { applicationEndpoints } from '../../amorg-common/applicationEndpoints';
import { clientApi } from '../../api/clientApi';
import { getMaybeActiveEmployeeOrLogin } from '../../api/serverApiHelpers';
import { LinkButton } from '../../designSystem/button/LinkButton';
import { PortalLayout } from './wrapperLayouts/PortalLayout';
import { SingleColumnLayout } from '../_layouts/SingleColumnLayout';
import { PageHeader } from '../../designSystem/PageHeader';
import { P } from '../../designSystem/typography/Body';
import { EmployeePortalPageProvider } from '../_contexts/EmployeePortalPageContext';

type EmployeePageWrapperProps = {
    disablePortalStatusCheck?: boolean,
    children: React.ReactNode;
};

export const EmployeePageWrapper: React.FunctionComponent<EmployeePageWrapperProps> = (props: EmployeePageWrapperProps) => 
{
    const [activeUser, setActiveUser] = React.useState<UserToken | EmployeeToken | null>(null);
    const [portalDisabed, setPortalDisabled] = React.useState(false);

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            const result = await getMaybeActiveEmployeeOrLogin();
            setActiveUser(result);
            if (!props.disablePortalStatusCheck)
            {
                const options = await clientApi.portal.getLoginOptions(result.siteId);
                setPortalDisabled(!options.enabled);
            }
        };
        getData();
    }, []);

    const allowed = activeUser !== null && !portalDisabed;

    const navigationShared = <>
        {activeUser?.type === 'user' && permissionGroupHelper.hasMinimumPermissionGroup(activeUser.permissionGroupId, 'member') &&
            <LinkButton
                variant={"clean"}
                href={applicationEndpoints.root}
                icon="arrows_arrow_arrowBack"
                text="AMO portalen"
            />
        }
        <LinkButton
            variant={"clean"}
            href={applicationEndpoints.portal}
            icon="navigation_home"
            text="Dashboard"
        />
        <LinkButton
            variant={"clean"}
            href={applicationEndpoints.portal_organization}
            icon="interface_user_team"
            text="Organisationen"
        />
        <LinkButton
            variant={"clean"}
            href={applicationEndpoints.portal_survey_reports}
            icon="list_alt"
            text="Rapporter"
        />
        <LinkButton
            variant={"clean"}
            href={applicationEndpoints.portal_files}
            icon="data_files_document"
            text="Dokumenter og filer"
        />
        <LinkButton
            variant={"clean"}
            href={applicationEndpoints.portal_links}
            icon="interface_actions_link"
            text="Links"
        />
        <LinkButton
            variant={"clean"}
            href={applicationEndpoints.portal_logout}
            icon="logout"
            text="Log ud"
        />
        </>


    return (
        <EmployeePortalPageProvider user={activeUser}>
            <PortalLayout navigation={allowed ? navigationShared : undefined}>
                {allowed && props.children}

                {!allowed &&
                    <>
                        <PageHeader narrow headerText="Hov" />
                        <SingleColumnLayout narrow>
                            <P>Hov! Du er havnet på en side, som du ikke har adgang til.</P>
                        </SingleColumnLayout>
                    </>
                }
            </PortalLayout>
        </EmployeePortalPageProvider>
    );
};